/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import Joi from 'joi';
import { isOccasionHoliday, isValidDate } from './Helpers';

export const schema = Joi.object({
    customer: Joi.object({
        firstName: Joi.string().trim().pattern(/^[A-Za-z][A-Za-z0-9.' -]*$/).max(14).required().messages({
            'string.empty': 'First name is required',
            'string.pattern.base': 'First name can only contain letters, spaces, dots, and hyphens',
            'string.max': 'First name is too long',
        }),
        lastName: Joi.string().trim().pattern(/^[A-Za-z][A-Za-z0-9.' -]*$/).max(14).required().messages({
            'string.empty': 'Last name is required',
            'string.pattern.base': 'Last name can only contain letters, spaces, dots, and hyphens',
            'string.max': 'Last name is too long',
        }),
        email: Joi.string().trim().required().messages({
            "string.empty": "Email is required",
        }),
    }),
    recipients: Joi.array().items(
        Joi.object().keys({
            rcpFirstName: Joi.string().trim().pattern(/^[a-zA-Z ]+$/).max(14).required().messages({
                'string.empty': 'First name is required',
                'string.pattern.base': 'Please use only alphabetic characters',
                'string.max': 'First name is too long',
            }),
            rcpLastName: Joi.string().trim().pattern(/^[a-zA-Z ]+$/).max(14).required().messages({
                'string.empty': 'Last name is required',
                'string.pattern.base': 'Please use only alphabetic characters',
                'string.max': 'Last name is too long',
            }),
            occasions: Joi.array().items(
                Joi.object({
                    occasion: Joi.string().allow('').optional(),
                    date: Joi.string().allow('').optional(),
                }).custom((value, helpers) => {

                    if ((value.occasion && !value.date) && !isOccasionHoliday(value.occasion)) {
                        return helpers.error('any.required', {
                            custom: {
                                message: 'Date is required',
                            },
                        });
                    }

                    if (value.date && !value.occasion) {
                        return helpers.error('any.required', {
                            custom: {
                                message: 'Occasion is required',
                            },
                        });
                    }

                    if (value.date && !isValidDate(value.date)) {
                        return helpers.error('any.required', {
                            custom: {
                                message: 'Date must be in MM/DD format',
                            },
                        });
                    }

                    return value;
                }),
            ).messages({
                'any.required': '{{#custom.message}}',
            }),
        })
    ),
});
